/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// reactstrap components
import Swal from "sweetalert2";
import {
  Badge,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Table,
  Container,
  Row,
  Button,
  Col,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  UncontrolledTooltip,
  Dropdown,
} from "reactstrap";
import { BiDotsVertical } from "react-icons/bi";
// core components
import Header from "components/Headers/Header.js";
import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { CSVLink } from "react-csv";
import { FcDataBackup } from "react-icons/fc";

// core components

const BlogIndex = () => {
  //fetching api data

  const [toggle, setToggle] = useState(false);

  const handleToggle = () => {
    setToggle(!toggle);
  };

  var arrayForDeletion = [];
  const [data, setData] = useState([]);
  const [contacts, setContacts] = useState(data);

  const [newContact, setNewContact] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    message: "",
    file: "",
  });

  const fetchContacts = () => {
    axios
      .get("https://backend.tror.ai/api/getAllContacts")
      .then((res) => {
        console.log(res.data.result);
        setData(res.data.result);
        setContacts(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const myContacts = contacts.map((contact) => {
    return {
      name: contact.name,
      email: contact.email,
      phone: contact.phoneNumber,
      message: contact.message,
      file: contact.file,
    };
  });

  const noDataToDelete = () => {
    Swal.fire({
      title: "No data to delete",
      icon: "warning",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "OK",
    });
  };

  const headers = [
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Phone Number", key: "phone" },
    { label: "Message", key: "message" },
    { label: "File", key: "file" },
  ];

  const csvReport = {
    filename: "contactForms.csv",
    headers: headers,
    data: myContacts,
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        axios
          .delete(`https://backend.tror.ai/api/deleteContact/${id}`)
          .then((res) => {
            fetchContacts();
            Swal.fire("Deleted!", "Contact has been deleted.", "success");
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const deleteAll = () => {
    Swal.fire({
      title: "Are you sure to delete?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        axios
          .delete("https://backend.tror.ai/api/deleteAllContacts")
          .then((res) => {
            fetchContacts();
            Swal.fire({
              title: "Are you sure?",
              text: "You won't be able to revert this!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const [file_upload, setFile_upload] = useState("");

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();

    formData.append("name", newContact.name);
    formData.append("email", newContact.email);
    formData.append("phoneNumber", newContact.phoneNumber);
    formData.append("message", newContact.message);
    formData.append("file", file_upload);

    axios
      .post("https://backend.tror.ai/api/contact", formData)
      .then((res) => {
        Swal.fire({
          title: "Success",
          type: "success",
          text: "Contact Data has been added successfully",
        }).then((result) => {
          if (result.value) {
            fetchContacts();
            setNewContact({
              name: "",
              email: "",
              phoneNumber: "",
              message: "",
              file: "",
            });

            document.getElementById("File").value = "";
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  return (
    <>
      <Header />
      {toggle === false ? (
        <Container className="mt--7" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <Col xs="5">
                      <h3 className="mb-0">Contact Data</h3>
                    </Col>
                    {/*Search bar*/}
                    <Col className="text-center" xs="2">
                      <Input
                        type="text"
                        placeholder="Search..."
                        style={{
                          height: "28px",
                          width: "300px",
                          position: "relative",
                          right: "35%",
                        }}
                        onChange={(e) => {
                          if (e.target.value.length == 0) {
                            setContacts(data);
                          } else {
                            const search = e.target.value;

                            const newData = data.filter((contact) => {
                              return (
                                contact.name
                                  .toLowerCase()
                                  .includes(search.toLowerCase()) ||
                                contact.email
                                  .toLowerCase()
                                  .includes(search.toLowerCase()) ||
                                contact.phoneNumber
                                  .toLowerCase()
                                  .includes(search.toLowerCase()) ||
                                contact.message
                                  .toLowerCase()
                                  .includes(search.toLowerCase())
                              );
                            });
                            setContacts(newData);
                          }
                        }}
                      />
                    </Col>
                    <Col className="text-right">
                      <Button
                        href="#pablo"
                        id="deleteCheckedItem"
                        style={{
                          backgroundColor: "#ff0000",
                          color: "#fff",
                        }}
                        size="sm"
                        onClick={() => {
                          console.log("AbC");
                          // fetch(
                          //   "https://backend.tror.ai/api/deleteMultipleContacts",
                          //   {
                          //     method: "DELETE",
                          //     headers: {
                          //       "Content-Type": "application/json",
                          //     },
                          //     body: JSON.stringify({
                          //       contactIds: arrayForDeletion,
                          //     }),
                          //   }
                          // ).then((res) => {
                            Swal.fire({
                              title: `${arrayForDeletion.length === 0 ? "No item selected" : "Are you sure?"}`,
                              text: `${arrayForDeletion.length === 0 ? "Please select any one item before deleting" : "You won't be able to revert this!"}`,
                              type: "warning",
                              showCancelButton: true,
                            }).then((result) => {
                              if(result.value){
                                fetch(
                                  "https://backend.tror.ai/api/deleteMultipleContacts",
                                  {
                                    method: "DELETE",
                                    headers: {
                                      "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify({
                                      contactIds: arrayForDeletion,
                                    }),
                                  }
                                )
                                fetchContacts();
                              }
                              document
                                .querySelectorAll("input[type=checkbox]")
                                .forEach((element) => {
                                  element.checked = false;
                                });

                              arrayForDeletion = [];
                              fetchContacts();
                            });
                          // });
                        }}
                      >
                        Delete Checked Row
                      </Button>
                      <Button
                        href="#pablo"
                        style={{
                          backgroundColor: "green",
                        }}
                        size="sm"
                      >
                        <CSVLink
                          {...csvReport}
                          style={{
                            color: "white",
                          }}
                        >
                          Download CSV
                        </CSVLink>
                      </Button>
                      <Button
                        color="primary"
                        onClick={(e) => {
                          handleToggle(e);
                        }}
                        size="sm"
                      >
                        Add New
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col"></th>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Phone Number</th>
                      <th scope="col">Message</th>
                      <th scope="col">File</th>
                      <th scope="col" />
                    </tr>
                  </thead>
                  {contacts.length > 0 ? (
                    <tbody>
                      {contacts.map((contact) => (
                        <tr>
                          <td>
                            <input
                              type="checkbox"
                              // className="custom-control-input"
                              style={{
                                width: "px",
                                height: "20px",
                              }}
                              id="CheckAllZ"
                              onChange={(e) => {
                                if (e.target.checked) {
                                  // "background-color: red, color: #fff, position: relative, left: 60%";
                                  arrayForDeletion.push(contact._id);
                                } else {
                                  arrayForDeletion.splice(
                                    arrayForDeletion.indexOf(contact._id),
                                    1
                                  );
                                }
                              }}
                            />
                          </td>
                          <th scope="row">
                            <Media className="align-items-center">
                              <Media>
                                <span className="mb-0 text-sm">
                                  {contact.name}
                                </span>
                              </Media>
                            </Media>
                          </th>

                          {/*Article Category*/}

                          <td>{contact.email}</td>
                          <td>{contact.phoneNumber}</td>
                          <td>{contact.message}</td>

                          <td>
                            <a href={`${contact.file}`}>Link</a>
                          </td>
                          <td className="text-right">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className="btn-icon-only text-dark"
                                href="#pablo"
                                role="button"
                                size="sm"
                                color=""
                                onClick={(e) => e.preventDefault()}
                              >
                                <BiDotsVertical />
                              </DropdownToggle>
                              <DropdownMenu
                                className="dropdown-menu-arrow"
                                right
                              >
                                <DropdownItem
                                  href="#pablo"
                                  onClick={(e) => {
                                    handleDelete(contact._id);
                                  }}
                                >
                                  Delete
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>

                          {/*Article Options*/}
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="8">No Contacts Found.</td>
                      </tr>
                    </tbody>
                  )}
                </Table>
                {/* <Button
                  className="primary"
                  style={{
                    backgroundColor: "#5E72E4",
                    color: "white",
                    marginTop: "20px",
                  }}
                  onClick={contacts.length > 0 ? deleteAll : noDataToDelete}
                >
                  Delete All
                </Button> */}
              </Card>
            </div>
          </Row>
        </Container>
      ) : (
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">Add New Contact</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        // href="/blogs"
                        onClick={(e) => {
                          handleToggle(e);
                          fetchContacts();
                        }}
                        size="sm"
                      >
                        Back to list
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form id="form">
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-username"
                            >
                              Name
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-title"
                              placeholder="name"
                              name="name"
                              value={newContact.name}
                              type="text"
                              onChange={(e) => {
                                setNewContact({
                                  ...newContact,
                                  name: e.target.value,
                                });
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-username"
                            >
                              Email
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-title"
                              placeholder="Email"
                              value={newContact.email}
                              name="email"
                              type="text"
                              onChange={(e) => {
                                setNewContact({
                                  ...newContact,
                                  email: e.target.value,
                                });
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-username"
                            >
                              Phone Number
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-title"
                              placeholder="phone number"
                              value={newContact.phoneNumber}
                              name="phoneNumber"
                              type="text"
                              onChange={(e) => {
                                setNewContact({
                                  ...newContact,
                                  phoneNumber: e.target.value,
                                });
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-username"
                            >
                              Message
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-title"
                              placeholder="message"
                              value={newContact.message}
                              name="message"
                              type="text"
                              onChange={(e) => {
                                setNewContact({
                                  ...newContact,
                                  message: e.target.value,
                                });
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-username"
                            >
                              Upload File
                            </label>
                            <Input
                              className="form-control"
                              id="File"
                              type="file"
                              name="file"
                              onChange={(e) => {
                                const file_upload = e.target.files[0];

                                setFile_upload(file_upload);
                                console.log("newContact", newContact);
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="12">
                          <FormGroup>
                            <div className="text-right">
                              <Button
                                color="primary"
                                onClick={(e) => {
                                  handleOnSubmit(e);
                                }}
                              >
                                Save
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    <hr className="my-4" />
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};

export default BlogIndex;
